export const status = [
  { value: 'Solicitado' },
  { value: 'Confirmado' },
  { value: 'Reagendado' },
  { value: 'Atendido' },
  { value: 'Concluído' },
  { value: 'Cancelado' }
];
